(function () {
  function initHero(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.life-col-hero__slide'));
    if (slides.length < 2) return;

    var i = slides.findIndex(function (s) {
      return s.classList.contains('is-active');
    });
    if (i < 0) i = 0;

    var autoplay = parseInt(root.getAttribute('data-autoplay'), 10) || 7000;
    var timer = null;

    function go(next) {
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      i = (next + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
    }

    function next() {
      go(i + 1);
    }
    function prev() {
      go(i - 1);
    }

    function start() {
      stop();
      timer = setInterval(next, autoplay);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    var prevBtn = root.querySelector('[data-life-col-hero-prev]');
    var nextBtn = root.querySelector('[data-life-col-hero-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        start();
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  function boot() {
    document.querySelectorAll('[data-life-col-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
